<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <div>
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Centro de custo
          </h2>
        </div>
        <div class="float-right">
          <div class="grid gap-4 grid-flow-col auto-cols-max">
            <div>
              <inertia-link :href="route('centro-custo.index')">Lista</inertia-link>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div>
      <div class="max-w-4xl mx-auto py-2 sm:px-2 lg:px-2">
        <form @submit.prevent="save">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white">
              <div class="grid grid-cols-1 py-2">

                <div class="col-span-12 sm:col-span-2 md:py-4">
                  <label class="block  text-lg text-gray-700">
                    {{centroCusto.nome}}
                  </label>

                </div>

                <div class="col-span-12 sm:col-span-2">
                  <label class="block font-medium text-sm text-gray-700">
                    Filial
                  </label>
                  <el-select
                    class="mt-1 w-full "
                    v-model="form.filial_id"
                    filterable
                  >
                    <el-option
                      v-for="filial in filiais"
                      :key="filial.id"
                      :value="filial.id"
                      :label="`${filial.id} - ${filial.nome}`"
                    ></el-option>
                  </el-select>
                  <jet-input-error
                    :message="form.errors.filial_id"
                    class="mt-2"
                  />
                </div>

              </div>
            </div>
            <div class="flex items-center justify-end px-4  bg-gray-50 text-right sm:px-6">
              <jet-action-message
                :on="form.recentlySuccessful"
                class="mr-3"
              > Salvo.</jet-action-message>
            </div>
            <div class="flex flex-row-reverse space-x-4 space-x-reverse px-4  py-4 sm:py-6 bg-gray-50">
              <button-primary
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
              > Salvar
              </button-primary>
              <button-secondary @click.native="$inertia.get(route('centro-custo.index'))">
                Cancelar
              </button-secondary>
            </div>
          </div>
        </form>
        <div>
          <div class="relative">
            <div class="py-2 px-1">
              <span class="text-xl text-gray-500"> Acompanhantes</span>
            </div>
            <div class="absolute top-3 right-1 h-4 text-gray-600">
              <i
                class="fas fa-plus cursor-pointer"
                @click="openNovo = true"
              ></i>
            </div>
            <div class="shadow overflow-hidden sm:rounded-md">
              <div class="px-4 py-5 bg-white">
                <div>
                  <div
                    class="bg-white rounded my-6"
                    v-if="hasAcompanhantes"
                  >
                    <table class="text-left w-full border-collapse">
                      <thead class="bg-gray-700 text-white">
                        <tr>

                          <th :class="headerTable">
                            Nome
                          </th>
                          <th :class="headerTable">
                            Email
                          </th>
                          <th :class="headerTable">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in centroCusto.acompanhantes"
                          :key="item.pivot.id"
                          class="hover:bg-grey-lighter"
                        >

                          <td class="py-2 px-6 border-b border-grey-light text-xs whitespace-nowrap overflow-x-auto">
                            {{item.name}}
                          </td>
                          <td class="py-2 px-6 border-b border-grey-light text-xs whitespace-nowrap overflow-x-auto">
                            {{item.email}}
                          </td>
                          <td class="py-2 px-6 border-b border-grey-light text-xs">
                            <div class="flex space-x-4">
                              <el-popconfirm
                                title="Deseja realmente excluir?"
                                confirm-button-text="Sim"
                                cancel-button-text="Não"
                                @confirm="destroy(item.pivot.id)"
                              >
                                <div
                                  slot="reference"
                                  :class="{ 'opacity-25': formDelete.processing }"
                                  :disabled="formDelete.processing"
                                >
                                  <icon-delete></icon-delete>
                                </div>
                              </el-popconfirm>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else>
                    <alert-warning message="Sem acompanhantes cadastrados"></alert-warning>
                  </div>
                </div>
              </div>
            </div>
            <jet-modal
              :show="openNovo"
              @close="openNovo = false"
              max-width="4xl"
            >
              <AcompanhanteNovo
                :centro-custo-id="centroCusto.id"
                @close="openNovo = false"
              ></AcompanhanteNovo>
            </jet-modal>
          </div>

        </div>
      </div>
    </div>

  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import JetModal from '@/Jetstream/Modal';
import AlertWarning from '@/Components/AlertWarning';
import IconDelete from '@/Components/IconDelete';
import AcompanhanteNovo from './AcompanhanteNovo';
import JetInputError from '@/Jetstream/InputError'
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import JetActionMessage from '@/Jetstream/ActionMessage'
export default {
  components: {
    AppLayout, JetModal, AlertWarning, AcompanhanteNovo, IconDelete, ButtonPrimary, ButtonSecondary,
    JetInputError, JetActionMessage,
  },
  props: ['centroCusto', 'filiais'],
  data() {
    return {
      openNovo: false,
      headerTable: 'py-2 px-6 bg-grey-lightest font-bold text-sm text-grey-dark border-b border-grey-light',
      formDelete:
        this.$inertia.form({
          '_method': 'DELETE',
          id: '',
        }, {
          bag: 'deleteCandidato'
        }),
      form:
        this.$inertia.form({
          filial_id: this.centroCusto.filial_id,
        }, {
          bag: 'edit'
        }),
    }
  },
  computed: {
    hasAcompanhantes() {
      return this.centroCusto.acompanhantes.length;
    }
  },
  methods: {
    destroy(id) {
      this.formDelete.id = id;
      this.formDelete.post(route('centro-custo-acompanhantes.destroy', id), {
        preserveScroll: true,
        onSuccess: () => this.isLoading = false
      })
    },
    save() {
      this.form.clearErrors();
      this.form.put(route('centro-custo.update', this.centroCusto.id), {
        preserveScroll: true
      });
    }
  }
}
</script>

<style>
</style>
